import { motion } from 'framer-motion';
import { useMemo } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

import { SideBar } from './components/SideBar';

import { Button, Modal, NavBar } from '@/components';
import useEditMyAccount from '@/hooks/useEditMyAccount';
import { useIsDesktop } from '@/hooks/useIsDesktop';
import { useMetaData } from '@/hooks/useMetaData';
import ROUTES from '@/router/routes';
import { FADE_IN_OUT } from '@/utils';

export const EditMyAccountLayout = () => {
  const { data, setEditMyAccount } = useEditMyAccount();

  const { isMobile } = useIsDesktop();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const optionsViews = useMemo(() => {
    const path = pathname.substring(pathname.lastIndexOf('/') + 1);
    const title = path
      .replace(/-/g, ' ') // guiones -> espacios
      .toLowerCase()
      .replace(/^./, (c) => c.toUpperCase());

    return {
      title:
        pathname === ROUTES.editAccount.menu
          ? 'Editar perfil'
          : title.replace('campanas', 'campañas'),
      showMenu: pathname === ROUTES.editAccount.menu,
    };
  }, [pathname]);

  useMetaData({
    title: 'Mi perfil',
  });

  const leftContent = useMemo(() => {
    if (!optionsViews.showMenu) {
      return {
        backAction: () => {
          navigate(ROUTES.editAccount.menu);
        },
      };
    } else {
      return {
        showMenuAction: true,
        items: true,
      };
    }
  }, [navigate, optionsViews.showMenu]);

  return (
    <>
      <NavBar
        desktop
        heightAuto="auto"
        mobile={{
          leftContent,
          centerContent: {
            title: optionsViews.title,
          },
        }}
      >
        <div
          className={`flex ${
            optionsViews.title.includes('personales')
              ? 'h-full'
              : 'h-screen lg:min-h-[720px]'
          } ${isMobile ? 'overflow-auto pb-14' : ''}`}
        >
          {!isMobile && (
            <div className="flex-1 lg:max-w-[450px] mb-3 lg:mb-0">
              <SideBar />
            </div>
          )}
          <div className="flex-1 max-w-[790px]">
            <motion.div
              key={location?.pathname}
              animate={'show'}
              initial="hide"
              variants={FADE_IN_OUT}
            >
              <Outlet />
            </motion.div>
          </div>
        </div>
      </NavBar>
      <Modal
        closeOutside={false}
        controlledOnClose={() =>
          setEditMyAccount({ showModalInfoChange: false })
        }
        isControlledOpen={Boolean(data?.showModalInfoChange)}
        render={() => (
          <div className="space-y-10 mb-6">
            <h1 className="text-base text-gdt-gray font-semibold text-center">
              Si realizaste algún cambio debés confirmarlo antes de salir.
              ¿Querés revisar tus datos?
            </h1>
            <div className="flex space-x-4">
              <Button
                className="flex-1"
                type="button"
                variant="secondary"
                onClick={() => {
                  setEditMyAccount({ showModalInfoChange: false });
                }}
              >
                Cancelar
              </Button>
              <Button
                className="flex-1 space-x-2"
                type="button"
                variant="primary"
                onClick={() => setEditMyAccount({ showModalInfoChange: false })}
              >
                Aceptar
              </Button>
            </div>
          </div>
        )}
        showCloseButton={false}
        size="xs"
        variant="controlled"
      />
    </>
  );
};
